import { createWebHistory, createRouter } from "vue-router";
// import Home from "./components/Home.vue";
import PortalDjbr from "./components/PortalDjbr.vue";
import Licencia from "./components/Licencia.vue";
import AcercaDe from "./components/AcercaDe.vue";
import AvisoLegal from "./components/AvisoLegal.vue";
import Staff from "./components/Staff.vue";

const routes = [
    {
        path: "/",
        // name: "Home",
        component: PortalDjbr
    },
    {
        path: "/portaldjbr",
        name: "PortalDjbr",
        component: PortalDjbr
    },
    {
        path: "/licencia",
        component: Licencia
    },
    {
        path: "/aviso-legal",
        component: AvisoLegal
    },
    {
        path: "/acerca-de",
        component: AcercaDe
    },
    {
        path: "/staff",
        component: Staff
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;